module.exports = __webpack_public_path__ + "media/images/player_fm-4e6a5e7478614fc5ba48f29c03fc6aea.png";